import React from 'react';
import { Form, Input, Tag, Button, Spin, Icon, Tooltip, Progress, Popconfirm, Switch } from 'antd';
import Avatar from './imageupload';
import VideoUpload from './videoupload';
import EditableItem from './editable';
import AddItem from './additem';

const { TextArea } = Input;
const antIcon = progress => (
  <Progress
    type="circle"
    percent={progress}
    format={() => (progress === 100 ? 'Done' : `${progress}%`)}
    width={80}
  />
);

export default ({
  courseData,
  media,uploadMedia,
  refreshVideos,refresh,
  profile,getMedia,
  handleSubmit,
  handleInputChange,
  handleClose,
  saveInputRef,
  handleInputConfirm,
  showInput,
  handleImageChange,
  progress,
  handleVideoChange,
  getFieldDecorator,
  handleSaveEditable,
  loading,
  normFile,
  setFieldsValue,
  showRequirementInput,
  showYouWillLearnInput,
  handleAddRequirement,
  handleAddYouWillLearn,
  handleCancelYouWillLearn,
  handleAddRequirementInput,
  handleAddYouWillLearnInput,
  handleCancelRequirement,
  requirements,
  tagName,
  tags,
  inputVisible,
  youWillLearn,
  imageFileList,videoUrl,
  title,subTitle,description,
  handleCourseDelete,
  handleNewCourse,
  handleSubmitAsDraft
}) => (
  <Spin indicator={antIcon(progress)} spinning={loading}>
    <Form onSubmit={handleSubmit} className="course-form">
      <Form.Item label="Course Title">
        {getFieldDecorator('title', {
          initialValue:title,
          rules: [{ required: true, message: 'Please input course title' }]
        })(
          <Input
            name="title"
            onChange={handleInputChange}
            placeholder="Course Title"
          />
        )}
      </Form.Item>

      <Form.Item label="Course Subtitle">
        {getFieldDecorator('subtitle', {
          initialValue:subTitle,
          rules: [{ required: true, message: 'Please input course subtitle' }]
        })(
          <Input
            name="subTitle"
            onChange={handleInputChange}
            placeholder="Course Subtitle"
          />
        )}
      </Form.Item>

      <Form.Item label="Course Description">
        {getFieldDecorator('description', {
          initialValue:description,
          rules: [
            { required: true, message: 'Please input course description' }
          ]
        })(
          <TextArea name="description" onChange={handleInputChange} rows={4} />
        )}
      </Form.Item>

      <Form.Item label="Course Tags">
        <div>
          {tags && tags.map((tag) => {
            const isLongTag = tag.length > 20;
            const tagElem = (
              <Tag key={tag} closable onClose={() => handleClose(tag)}>
                {isLongTag ? `${tag.slice(0, 20)}...` : tag}
              </Tag>
            );
            return isLongTag ? (
              <Tooltip title={tag} key={tag}>
                {tagElem}
              </Tooltip>
            ) : (
              tagElem
            );
          })}
          {inputVisible && (
            <Input
              ref={saveInputRef}
              type="text"
              size="small"
              style={{ width: 200 }}
              name="tagName"
              value={tagName}
              onChange={handleInputChange}
              onBlur={handleInputConfirm}
              onPressEnter={handleInputConfirm}
            />
          )}
          {!inputVisible && (
            <Tag
              onClick={showInput}
              style={{ background: '#fff', borderStyle: 'dashed' }}
            >
              <Icon type="plus" /> New Tag
            </Tag>
          )}
        </div>
      </Form.Item>

      <Form.Item label="Course Image">
        <Avatar
        profile={profile}
        imageFileList={imageFileList}
          getFieldDecorator={getFieldDecorator}
          handleImageChange={handleImageChange}
        />
      </Form.Item>

      <Form.Item label="Course Promotional Video">
        <VideoUpload
            media={media}
            uploadMedia={uploadMedia}
            refreshVideos={refreshVideos}
            refresh={refresh}
            getMedia={getMedia}
            profile={profile}
          videoUrl={videoUrl}
          getFieldDecorator={getFieldDecorator}
          handleVideoChange={handleVideoChange}
        />
      </Form.Item>

      <Form.Item label="Course Requirements">
        <div style={{ textAlign: 'right', height: 15 }}>
          <Button
            style={{ bottom: 28 }}
            onClick={() => handleAddRequirementInput()}
            size="small"
            ghost
            type="primary"
            icon="plus"
          >
            Add
          </Button>
        </div>
        {showRequirementInput ? (
          <AddItem
            name="requirement"
            handleAddItem={handleAddRequirement}
            handleCancelItem={handleCancelRequirement}
          />
        ) : (
          ''
        )}
        <EditableItem
          name="requirements"
          items={requirements}
          handleSaveEditable={handleSaveEditable}
        />
      </Form.Item>

      <Form.Item label="What you will learn">
        <div style={{ textAlign: 'right', height: 15 }}>
          <Button
            style={{ bottom: 28 }}
            onClick={() => handleAddYouWillLearnInput()}
            size="small"
            ghost
            type="primary"
            icon="plus"
          >
            Add
          </Button>
        </div>
        {showYouWillLearnInput ? (
          <AddItem
            name="youWillLearn"
            handleAddItem={handleAddYouWillLearn}
            handleCancelItem={handleCancelYouWillLearn}
          />
        ) : (
          ''
        )}
        <EditableItem
          name="youWillLearn"
          items={youWillLearn}
          handleSaveEditable={handleSaveEditable}
        />
      </Form.Item>

      {courseData.isNewCourse ? 
      <Form.Item label="Set as new course" className="switch-item">
        <Switch className="switch-control" defaultChecked onChange={handleNewCourse}/>
      </Form.Item>
      :
      <Form.Item label="Set as new course" className="switch-item">
        <Switch className="switch-control" onChange={handleNewCourse}/>
      </Form.Item>

      }

      <Form.Item className="editcourse-btns">
        <Button type="primary" htmlType="submit">
        Publish
        </Button>
        <Popconfirm
        title="Are you sure you want to save this course as draft?"
        onConfirm={handleSubmitAsDraft}
        // onCancel={cancel}
        okText="Yes"
        cancelText="No"
      >
        <Button className="delete-btn"> Save as Draft </Button>
      </Popconfirm> 
        
        <Popconfirm
          title="Are you sure delete this course?"
          onConfirm={handleCourseDelete}
          // onCancel={cancel}
          okText="Yes"
          cancelText="No"
        >
          <Button type="danger" className="delete-btn"> Delete <Icon type="delete" /></Button>
        </Popconfirm>
      </Form.Item>
    </Form>
  </Spin>
);
